// extracted by mini-css-extract-plugin
export var experienceSection = "Experience-module--experienceSection--1hABT";
export var cardWrapper = "Experience-module--cardWrapper--2Z9Sp";
export var card = "Experience-module--card--cr9Cf";